import { render } from "./WizardComponent.vue?vue&type=template&id=e4aca92c&scoped=true"
import script from "./WizardComponent.vue?vue&type=script&lang=js"
export * from "./WizardComponent.vue?vue&type=script&lang=js"

import "./WizardComponent.vue?vue&type=style&index=0&id=e4aca92c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4aca92c"]])

export default __exports__